import React, { FC } from 'react';

import { Trans, useTranslation } from 'react-i18next';

import { Separator, Title } from 'src/front/components/FormStyles';
import HistoryForm from './components/HistoryForm';

const ViewHistory: FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Title>
        <Trans i18nKey={t('callCenter_internetBanking_interbankMoneyTransfersHistory_title')} />
      </Title>
      <Separator />
      <HistoryForm />
    </>
  );
};
export default ViewHistory;
